import React, { useEffect, useState } from 'react';
import { Link, Outlet } from "react-router-dom";
import { List, ListItem, Grid, Typography, IconButton, Tooltip } from '@mui/material';
import { useLocation } from "react-router-dom";
import logo from '../../superadmin/assets/frs-logo2.svg';
import '../../superadmin/styles/layouts/common_sidebar.css';
import product_icon from '../../superadmin/assets/icons/product-icon.png';
// import transaction_icon from '../../superadmin/assets/icons/transaction-icon.png';
import dashboard_icon from '../../superadmin/assets/icons/dashboard.png';
import school_icon from '../../superadmin/assets/icons/school-2.png';
import inventory_icon from '../../superadmin/assets/icons/inventory.png';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { useGlobalContext } from '../../Contex';
import instance from '../../utils/Api';



const Sidebar = () => {
  const location = useLocation();
  //destructuring pathname from location
  const { pathname } = location;
  //Javascript split method to get the name of the path in array
  const splitLocation = pathname.split("/");
  const { collapsed, setCollapsed } = useGlobalContext();
  const [adminData, setAdminData] = useState({});
  const [url, setUrl] = useState(null);

  const handleToggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const companyData = async (req, res) => {
    try {
      const response = await instance.get('/Admins/getAdminById');
      setAdminData(response?.data?.data || {});
    } catch (error) {
      console.log(error);
    }
  }
  console.log(adminData);

  const loadPdf = async (data) => {
    // setLoading(true); // Start showing the skeleton while fetching
    try {
      const response = await instance.get(
        `/S3Image/getSignedImage?image=${adminData.logo}`
      );
      setUrl(response.data.image);
    } catch (error) {
      console.error("Error loading image:", error);
      // setLoading(false); // Stop loading on error
    }
  };
  useEffect(() => {
    loadPdf(adminData);
  }, [adminData]);
  useEffect(() => {
    companyData();
  }, []);


  return (
    <React.Fragment>
      <Grid container >
        <Grid item sm={1.4} md={collapsed ? 1 : 2.5} lg={collapsed ? 0.7 : 2} className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
          <div className='sidebar-content'>
            <div className='sidebar-logo '>
              <img src={url} alt='logo' />
              {/* {!collapsed && <Typography>FRS</Typography>} */}
            </div>
            {/* <div className='toggle-button'>
              <IconButton
                onClick={handleToggleSidebar}
              >
                {collapsed ? <ChevronRight /> : <ChevronLeft />}
              </IconButton>
            </div> */}
            <List>
              <Link to="/admin/dashboard">
                <Tooltip title="Dashboard" placement="right" arrow disableHoverListener={!collapsed}>
                  <ListItem className={splitLocation[1] === "admin" && splitLocation[2] === "dashboard" ? "active" : ""}>
                    <img src={dashboard_icon} alt='dashboard icon' />
                    {!collapsed && <span>Dashboard</span>}
                  </ListItem>
                </Tooltip>
              </Link>
              <Link to="/admin/wastePickers">
                <Tooltip title="Waste Picker's" placement="right" arrow disableHoverListener={!collapsed}>
                  <ListItem className={splitLocation[1] === "admin" && splitLocation[2] === "wastePickers" ? "active" : ""}>
                    <img src={inventory_icon} alt='inventory icon' />
                    {!collapsed && <span>Waste Picker's</span>}
                  </ListItem>
                </Tooltip>
              </Link>
              <Link to="/admin/products">
                <Tooltip title="Items's List" placement="right" arrow disableHoverListener={!collapsed}>
                  <ListItem className={splitLocation[1] === "admin" && splitLocation[2] === "products" ? "active" : ""}>
                    <img src={product_icon} alt='product icon' />
                    {!collapsed && <span>Item's List</span>}
                  </ListItem>
                </Tooltip>
              </Link>

              <Link to="/admin/transaction">
                <Tooltip title="transaction" placement="right" arrow disableHoverListener={!collapsed}>
                  <ListItem className={(splitLocation[1] === "admin" && splitLocation[2] === "transaction") || (splitLocation[1] === "admin" && splitLocation[2] === "inventory") || (splitLocation[1] === "admin" && splitLocation[2] === "transaction") || (splitLocation[1] === "admin" && splitLocation[2] === "student") ? "active" : ""}>
                    <img src={school_icon} alt='transaction icon' />
                    {!collapsed && <span>Transactions</span>}
                  </ListItem>
                </Tooltip>
              </Link>
              <Link to="/admin/Attendance">
                <Tooltip title="Attendance" placement="right" arrow disableHoverListener={!collapsed}>
                  <ListItem className={splitLocation[1] === "admin" && splitLocation[2] === "Attendance" ? "active" : ""}>
                    <img src={dashboard_icon} alt='dashboard icon' />
                    {!collapsed && <span>Attendance</span>}
                  </ListItem>
                </Tooltip>
              </Link>
              <Link to="/admin/reports">
                <Tooltip title="reports" placement="right" arrow disableHoverListener={!collapsed}>
                  <ListItem className={splitLocation[1] === "admin" && splitLocation[2] === "reports" ? "active" : ""}>
                    <img src={dashboard_icon} alt='reports icon' />
                    {!collapsed && <span>Reports</span>}
                  </ListItem>
                </Tooltip>
              </Link>

              {/* <Link to="/admin/transaction">
                <ListItem className={splitLocation[1] === "admin" && splitLocation[2] === "transaction" ? "active" : ""}>
                  <img src={transaction_icon} alt='transaction icon' />
                  <span>Transaction</span>
                </ListItem>
              </Link> */}
            </List>
          </div>
        </Grid>
        <Grid item sm={10.6} md={collapsed ? 11 : 9.5} lg={collapsed ? 11.3 : 10}>
          <Outlet />
        </Grid>
      </Grid>
    </React.Fragment>
  )
}

export default Sidebar;